module.exports = __webpack_public_path__ + "static/media/bgVideoMy.d1216db.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bgVideoMy.mp4
// module id = u4rh
// module chunks = 1